// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__tSkho","alertIcon":"ConfirmModal_alertIcon__3NU1U"};